var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyhop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "200.000000pt",
    height: "200.000000pt",
    viewBox: "0 0 200.000000 200.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,200.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M880 1960 c-143 -20 -313 -83 -427 -161 -69 -47 -188 -164 -239 -235 -53 -74 -125 -226 -147 -309 -25 -92 -39 -232 -32 -310 25 -268 119 -463 308 -641 184 -173 400 -258 657 -258 225 0 427 68 596 202 237 187 366 452 367 752 1 257 -83 472 -257 657 -148 157 -324 255 -524 293 -80 15 -229 20 -302 10z m9 -715 c30 -15 41 -33 41 -69 0 -31 -377 -406 -409 -406 -34 0 -57 16 -70 49 -10 24 -10 34 2 58 8 15 95 105 192 198 150 144 191 179 213 184 2 1 16 -6 31 -14z m649 -21 c21 -24 22 -32 22 -209 0 -196 -6 -225 -47 -244 -34 -16 -47 -14 -77 10 l-26 20 0 200 c0 209 4 233 43 249 30 12 58 3 85 -26z m-293 1 c25 -24 25 -25 25 -223 0 -179 -2 -202 -18 -223 -27 -33 -78 -30 -109 5 -20 24 -23 37 -23 119 l0 91 -118 -117 c-66 -64 -126 -117 -135 -117 -54 0 -96 55 -78 101 10 26 342 359 376 378 31 17 54 13 80 -14z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyhop);
export default __webpack_public_path__ + "static/media/moneyhop.2a938e86a19ef9b9f27d9cdebb084115.svg";
export { ForwardRef as ReactComponent };